/**
 * BlackWidow.js
 * The Black Widow Hero class
 */

import { Game } from "pixi_core";
import { Hero } from "./Hero";
import { DEFAULT_BLACK_WIDOW_TIMER_INCREASE, GameEvents } from "../Constants";

export class BlackWidow extends Hero {
    /**
     * @public
     * @param {Object} heroData
     */
    constructor(heroData) {
        super(heroData);

        /** @private @type {Number} */
        this._timerIncrease = Game.utils.assertNumber(heroData.TimerIncrease, DEFAULT_BLACK_WIDOW_TIMER_INCREASE);
    }

    /**
     * @public
     * @override
     */
    useAbility() {
        super.useAbility();
        Game.fire(GameEvents.eHERO_ABILITY_BLACK_WIDOW, this._timerIncrease);
        Game.audio.playSfx("IDSND_ABIL_BWIDOW_ACTIVATE");
    }
}
